import { useMutation } from "@tanstack/react-query";
import { saveLeatMappings } from "../../api/bLeatApi";

export const useSaveLeatMappings = () => {
  return useMutation({
    mutationKey: ["save-leat-mappings"],
    mutationFn: (data) => saveLeatMappings(data),
    onError: (error) => {
      console.error("Leat mapping save error:", error.response || error);
    },
  });
};
